<template>
    <div>
    	<gofix-text-field label="Photos" oneline>
            <template :slot="`gofixTextField:${slotValue}`">
                <div :class="classSlotValue">
                    <gofix-button v-if="editing" :class="['editRight', classBtn]" label="Edit" @click="showModal" noBorder fontNormal small></gofix-button>
                </div>
            </template>
            <template :slot="isSlotAfter ? 'gofixTextField:after': 'gofixTextField:before_value'">
                <div class="photosThumbOrderInfo mt-0">
                    <viewer-image :images="list">
                        <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                            <ul :class="['list-thumb', classList]">
                                <li v-for="(item,key) in images" v-if="key <= limitPhoto"  v-bind:key="key">
                                    <img v-if="key < limitPhoto" :alt="item.image_file_name"  src="img/loading.gif" v-auth-image="item.url.medium">
                                    <img v-if="key === limitPhoto" :alt="item.image_file_name" src="img/loading.gif" v-auth-image="item.url.medium" >
                                    <span v-if="attachments.length > limitPhoto && key === limitPhoto">{{ attachments.length - (limitPhoto + 1) }}+</span>
                                </li>
                            </ul>
                        </template>
                    </viewer-image>
                </div>
            </template>
        </gofix-text-field>
        <b-modal :no-close-on-backdrop="true" id="modal-EditPhoto" title="Edit Photos" hide-footer :centered="true" ref="modal-editPhoto" v-model="modal.open">
            <b-form>
                <b-form-group label="Photos" class="photosThumb mt-0">
                    <ul class="list-thumb">
                        <li v-for="(item,key) in modal.attachments" v-bind:key="key">
                            <!-- <img :src="item.url.thumb" alt="">  -->
                            <img v-auth-image="item.url.thumb" src="img/loading.gif" alt=""> 
                            <span class="delete" @click="deleteItem(item)">
                                <img src="img/close.png" alt="">
                            </span>
                        </li>
                    </ul>
                    <div class="upload-btn-wrapper">
                        <b-form-file id="fileInputMulti" v-model="modal.attachment" :plain="true" :multiple="true"></b-form-file>
                        <gofix-button class="m-3" label="add photo" outline></gofix-button>
                    </div>
                </b-form-group>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="upload" :loading="loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
const ViewerImage = () => import('@/views/plugins/ViewerImage.vue')
import moment from 'moment';
export default {
    name: 'box-photo',
    components: {
        ViewerImage
    },
    props: {
        attachments: {
            type: Array,
            default: () => []
        },
        slotValue: {
            type: String,
            default: 'after_value'
        },
        classSlotValue: {
            type: String,
            default: ''
        },
        classList: {
            type: String,
            default: ''
        },
        classBtn: {
            type: String,
            default: ''
        },
        isSlotAfter: {
            type: Boolean,
            default: false
        },
        limitPhoto: {
            type: Number,
            default: 5
        },
        open: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        isResetData: {
            type: Boolean,
            default: true
        },
        editing:{
            type:Boolean,
            default: true
        }
    },
    data: function () {
        return {
            is_reset: this.isResetData,
            list: this.attachments,
            modal : {
                open: this.open,
                loading: false,
                attachments: [],
                attachment: null,
            },
            data: {
                attachments: [],
                attachment_del_ids: []
            }
        }
    },
    watch: {
        isResetData: function(val) {
            this.is_reset = val;
        },
        open: function(val) {
            this.modal.open = val
        },
        "modal.open": function(val) {
            this.$emit('input', val);
        },
        "modal.attachment": function (val) {
            if (val) {
                val.forEach((file, index) => {
                    if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/gif') {
                        this.$bvToast.toast(file.name, {
                            title: 'Wrong Format Picture',
                            autoHideDelay: 2000,
                            variant: 'warning',
                            solid: true
                        });
                        return;
                    }
                    let tmp_moment = moment().valueOf() + index;
                    file.moment = tmp_moment;
                    let data = {
                        moment: tmp_moment,
                        url: {
                            original: URL.createObjectURL(file),
                            medium: URL.createObjectURL(file),
                            thumb: URL.createObjectURL(file)
                        }
                    };
                    this.data.attachments.push(file);
                    this.modal.attachments.push(data);
                });
            }
        },
        attachments: function(val) {
            this.list = val;
        }
    },
    methods: {
        showModal() {
            if(this.is_reset) {
                this.data.attachments = [];
            }
            
            this.data.attachment_del_ids = [];
            this.modal.attachments = JSON.parse(JSON.stringify(this.attachments));;
            this.modal.open = true;
        },
        upload() {
            this.$emit('upload-photo', {
                attachments: this.data.attachments,
                attachment_del_ids : this.data.attachment_del_ids,
                modal_attachments: this.modal.attachments
            });
        },
        deleteItem(img) {
            if(img.moment){
                this.modal.attachments = this.modal.attachments.filter(item => item.moment !== img.moment);
                this.data.attachments  = this.data.attachments.filter(item => item.moment !== img.moment);
            } else {
                this.data.attachment_del_ids.push(img.id);
                this.modal.attachments = this.modal.attachments.filter(item => item.id !== img.id);
            }
        },
         
    }
}
</script>

